import React from "react"

// Shared marketing footer. Same shape across the home page + /audit.
// Anchor links to #how-it-works / #faq only resolve on the home page;
// the others are first-class routes that work from anywhere.
function FooterColumn({ heading, children }) {
  return (
    <div className="flex flex-col gap-3">
      <p className="font-mono text-[10px] tracking-[0.15em] uppercase text-[color:var(--color-ink-tertiary)]">
        {heading}
      </p>
      {children}
    </div>
  )
}

function FooterLink({ href, children }) {
  return (
    <a
      href={href}
      className="font-sans text-[13px] text-[color:var(--color-ink-secondary)] hover:text-[color:var(--color-ink-primary)]"
    >
      {children}
    </a>
  )
}

export default function Footer() {
  return (
    <footer className="border-t border-[color:var(--color-rule)] bg-[color:var(--color-surface-card)] mt-auto">
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-[1.5fr_1fr_1fr_1fr] gap-12">
          <div className="flex flex-col gap-4">
            <a href="/" className="font-sans text-[15px] tracking-[-0.025em] font-medium">
              ShopShift<span className="text-[color:var(--color-ai)]">.</span>
            </a>
            <p className="font-sans text-[13px] text-[color:var(--color-ink-secondary)] leading-[1.6] max-w-xs">
              AI-powered conversion optimization for webshops. 30 days free, then $99 a month. Cancel any time.
            </p>
            <p className="font-mono text-[11px] tracking-[0.04em] text-[color:var(--color-ink-faint)] mt-4">
              Operated by SVEA IT · CVR 36606061 · Denmark
            </p>
          </div>

          <FooterColumn heading="Product">
            <FooterLink href="/#how-it-works">How it works</FooterLink>
            <FooterLink href="/pricing">Pricing</FooterLink>
            <FooterLink href="/learn">Learn</FooterLink>
            <FooterLink href="/#faq">FAQ</FooterLink>
            <FooterLink href="/users/sign_up">Start free trial</FooterLink>
          </FooterColumn>

          <FooterColumn heading="Legal">
            <FooterLink href="/terms">Terms</FooterLink>
            <FooterLink href="/privacy">Privacy</FooterLink>
            <FooterLink href="/cancellation-and-refunds">Cancellation</FooterLink>
            <FooterLink href="/subprocessors">Subprocessors</FooterLink>
          </FooterColumn>

          <FooterColumn heading="Company">
            <FooterLink href="/contact">Contact</FooterLink>
            <FooterLink href="mailto:support@shopshift.io">support@shopshift.io</FooterLink>
            <FooterLink href="/users/sign_in">Sign in</FooterLink>
          </FooterColumn>
        </div>

        <div className="mt-16 pt-8 border-t border-[color:var(--color-rule)] flex items-center justify-between flex-wrap gap-4">
          <p className="font-mono text-[11px] text-[color:var(--color-ink-faint)]">
            © {new Date().getFullYear()} SVEA IT (CVR 36606061)
          </p>
          <p className="font-mono text-[11px] text-[color:var(--color-ink-faint)]">
            v0.1
          </p>
        </div>
      </div>
    </footer>
  )
}
